// Angular Imports
import { Injectable, inject } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
// Angular Material Imports
import { MatIconRegistry } from '@angular/material/icon'

@Injectable({
	providedIn: 'root',
})
export class RegisterSvgAsIconService {
	readonly #iconRegistry = inject(MatIconRegistry)
	readonly #domSanitizer = inject(DomSanitizer)

	constructor() {
		// Operation
		this.#iconRegistry.addSvgIcon(
			'operation.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/operation.svg')
		)
		// Planning
		this.#iconRegistry.addSvgIcon(
			'planning.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/planificacion.svg')
		)
		// Drivers
		this.#iconRegistry.addSvgIcon(
			'drivers.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/conductores.svg')
		)
		// Personal
		this.#iconRegistry.addSvgIcon(
			'personal.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/personal.svg')
		)
		// Locations
		this.#iconRegistry.addSvgIcon(
			'locations.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/lugares.svg')
		)
		// Schedules
		this.#iconRegistry.addSvgIcon(
			'cronogramas.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/cronogramas.svg')
		)
		// Shifts
		this.#iconRegistry.addSvgIcon(
			'turnos.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/turnos.svg')
		)
		// Units
		this.#iconRegistry.addSvgIcon(
			'unidades.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/unidades.svg')
		)
		// Vehicles
		this.#iconRegistry.addSvgIcon(
			'vehiculos.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/vehiculos.svg')
		)
		// Documents
		this.#iconRegistry.addSvgIcon(
			'documentos.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/documentos.svg')
		)
		// Cron Jobs
		this.#iconRegistry.addSvgIcon(
			'cron-jobs.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/cron-jobs.svg')
		)
		// Administration
		this.#iconRegistry.addSvgIcon(
			'administracion.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/administracion.svg')
		)
		// Administration Schedule
		this.#iconRegistry.addSvgIcon(
			'admin-cronograma.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/admin-cronograma.svg')
		)
		// Administration Personal
		this.#iconRegistry.addSvgIcon(
			'admin-personal.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/admin-personal.svg')
		)
		// Administration Hours
		this.#iconRegistry.addSvgIcon(
			'admin-horarios.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/admin-horarios.svg')
		)
		// Administration Locations
		this.#iconRegistry.addSvgIcon(
			'admin-locaciones.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/admin-locaciones.svg')
		)
		// Rest Worked
		this.#iconRegistry.addSvgIcon(
			'rest-worked.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/rest-worked.svg')
		)
		// Dashboards (ICS / drivers)
		this.#iconRegistry.addSvgIcon(
			'dashboards.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/dashboards.svg')
		)
		// Square caret left solid
		this.#iconRegistry.addSvgIcon(
			'square-caret-left-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl(
				'assets/svgs/icons/square-caret-left-solid.svg'
			)
		)
		// Square caret right solid
		this.#iconRegistry.addSvgIcon(
			'square-caret-right-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl(
				'assets/svgs/icons/square-caret-right-solid.svg'
			)
		)
		// Circle user solid
		this.#iconRegistry.addSvgIcon(
			'circle-user-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/circle-user-solid.svg')
		)
		// Right from bracket solid
		this.#iconRegistry.addSvgIcon(
			'right-from-bracket-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl(
				'assets/svgs/icons/right-from-bracket-solid.svg'
			)
		)
		// Trash solid
		this.#iconRegistry.addSvgIcon(
			'trash-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/trash-solid.svg')
		)
		// Trash arrow up solid
		this.#iconRegistry.addSvgIcon(
			'trash-arrow-up-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl(
				'assets/svgs/icons/trash-arrow-up-solid.svg'
			)
		)
		// Square plus solid
		this.#iconRegistry.addSvgIcon(
			'square-plus-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/square-plus-solid.svg')
		)
		// Circle plus solid
		this.#iconRegistry.addSvgIcon(
			'circle-plus-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/circle-plus-solid.svg')
		)
		// Pen to square solid
		this.#iconRegistry.addSvgIcon(
			'pen-to-square-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/pen-to-square-solid.svg')
		)
		// Xmark solid
		this.#iconRegistry.addSvgIcon(
			'xmark-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/xmark-solid.svg')
		)
		// Grid vertical solid
		this.#iconRegistry.addSvgIcon(
			'grip-vertical-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/grip-vertical-solid.svg')
		)
		// Grip solid
		this.#iconRegistry.addSvgIcon(
			'grip-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/grip-solid.svg')
		)
		// Up right and down left from center solid
		this.#iconRegistry.addSvgIcon(
			'up-right-and-down-left-from-center-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl(
				'assets/svgs/icons/up-right-and-down-left-from-center-solid.svg'
			)
		)
		// Arrow left solid
		this.#iconRegistry.addSvgIcon(
			'arrow-left-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/arrow-left-solid.svg')
		)
		// Arrow right solid
		this.#iconRegistry.addSvgIcon(
			'arrow-right-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/arrow-right-solid.svg')
		)
		// Chevron right solid
		this.#iconRegistry.addSvgIcon(
			'chevron-right-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/chevron-right-solid.svg')
		)
		// Chevron left solid
		this.#iconRegistry.addSvgIcon(
			'chevron-left-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/chevron-left-solid.svg')
		)
		// Ellipsis vertical solid
		this.#iconRegistry.addSvgIcon(
			'ellipsis-vertical-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl(
				'assets/svgs/icons/ellipsis-vertical-solid.svg'
			)
		)
		// Filter solid
		this.#iconRegistry.addSvgIcon(
			'filter-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/filter-solid.svg')
		)
		// Filter circle xmark solid
		this.#iconRegistry.addSvgIcon(
			'filter-circle-xmark-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl(
				'assets/svgs/icons/filter-circle-xmark-solid.svg'
			)
		)
		// Arrows rotate solid
		this.#iconRegistry.addSvgIcon(
			'arrows-rotate-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/arrows-rotate-solid.svg')
		)
		// Arrow rotate left solid
		this.#iconRegistry.addSvgIcon(
			'arrows-rotate-left-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl(
				'assets/svgs/icons/arrow-rotate-left-solid.svg'
			)
		)
		// Arrow rotate right solid
		this.#iconRegistry.addSvgIcon(
			'arrows-rotate-right-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl(
				'assets/svgs/icons/arrow-rotate-right-solid.svg'
			)
		)
		// Expand more solid
		this.#iconRegistry.addSvgIcon(
			'expand-more.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/expand-more.svg')
		)
		// Regular Calendar
		this.#iconRegistry.addSvgIcon(
			'calendar-regular.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/calendar-regular.svg')
		)
		// Dod
		this.#iconRegistry.addSvgIcon(
			'dod.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/dod.svg')
		)
		// Flag Regular
		this.#iconRegistry.addSvgIcon(
			'flag-regular.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/flag-regular.svg')
		)
		// Flag Solid
		this.#iconRegistry.addSvgIcon(
			'flag-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/flag-solid.svg')
		)
		// Tag
		this.#iconRegistry.addSvgIcon(
			'tag-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/tag-solid.svg')
		)
		// User Tag
		this.#iconRegistry.addSvgIcon(
			'user-tag-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/user-tag-solid.svg')
		)
		// Circle Check
		this.#iconRegistry.addSvgIcon(
			'circle-check-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/circle-check-solid.svg')
		)
		// Circle Stop
		this.#iconRegistry.addSvgIcon(
			'circle-stop-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/circle-stop-solid.svg')
		)
		// Circle Xmark
		this.#iconRegistry.addSvgIcon(
			'circle-xmark-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/circle-xmark-solid.svg')
		)
		// Id Card Solid
		this.#iconRegistry.addSvgIcon(
			'id-card-clip-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/id-card-clip-solid.svg')
		)
		// Bolt Solid
		this.#iconRegistry.addSvgIcon(
			'bolt-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/bolt-solid.svg')
		)
		// Road Solid
		this.#iconRegistry.addSvgIcon(
			'road-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/road-solid.svg')
		)
		// Sort Down Solid
		this.#iconRegistry.addSvgIcon(
			'sort-down-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/sort-down-solid.svg')
		)
		// Sort Up Solid
		this.#iconRegistry.addSvgIcon(
			'sort-up-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/sort-up-solid.svg')
		)
		// Sort Solid
		this.#iconRegistry.addSvgIcon(
			'sort-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/sort-solid.svg')
		)
		// Magnifying Glass Solid
		this.#iconRegistry.addSvgIcon(
			'magnifying-glass-solid.svg',
			this.#domSanitizer.bypassSecurityTrustResourceUrl(
				'assets/svgs/icons/magnifying-glass-solid.svg'
			)
		)
	}
}
